import { createSlice } from "@reduxjs/toolkit";
import { toLogin } from "../actions/auth.actions";

const initialState = {
  login: {} as any,

  loading: false,
  error: null as unknown | null,
};
export const loginSlice = createSlice({
  name: "login",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toLogin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toLogin.fulfilled, (state, action) => {
      state.login = action.payload;
      state.loading = false;
    });
    builder.addCase(toLogin.rejected, (state, action) => {
      state.login = {};
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default loginSlice.reducer;
